import apiV2 from '@/api/v2';
export var ObjectStatus;
(function (ObjectStatus) {
    ObjectStatus["ACTIVE"] = "active";
    ObjectStatus["INACTIVE"] = "inactive";
    ObjectStatus["IN_OFFER"] = "in-offer";
})(ObjectStatus || (ObjectStatus = {}));
export const OBJECTS_API_PATH = 'objects';
export const updateObjectImportant = async (objectId, payload) => {
    await apiV2.patch(`objects/${objectId}`, payload);
};
